<template>
  <section :class="['row', {'row--slidup': isInView}]">
    <header class="row__animation">
      <video width="100%" height="100%" controls muted autoplay loop playsinline>
  <source src="@/assets/video/Caredo mix p01 07-09-2020 - w3.mp4" type="video/mp4">
Your browser does not support the video tag.
</video>
    </header>
  </section>
</template>

<script>
export default {
  name: 'benefits',
};
</script>

<style lang="scss" scoped>
.row{
  padding-top:0px;
  padding-bottom:0px;
    @media screen and (max-width: 900px) {
      padding-top:50px;
  }
}

.row__animation{
  height:56.25vw;
  width: 100%;
  position:relative;
  overflow: hidden;
}
video{
  object-fit: cover;
}

</style>
